import { createAsyncThunk } from "@reduxjs/toolkit";
import apiConfig from "constants/apiConfig";
import { fetchContentLibrary } from "services/api/content-library";
import { AuthState } from "slices/auth/reducer";
import { ERROR } from "types";
import { ContentLibraryFilters, ContentLibraryResponse, ContentLibrarySlice } from "types/campaign/content";
import { generateUniqueKey, isFresh } from "utils/helpers";

export const fetchContentLibraryThunk = createAsyncThunk<{library: ContentLibraryResponse, filters: ContentLibraryFilters, filterId: string }, {force?: boolean, filters: ContentLibraryFilters}, {rejectValue: string}>(
    'content-library',
    async ({force, filters}, {getState, rejectWithValue}) => {
        try {
            const STALE_TIME = apiConfig.FETCH_CONTENT_LIBRARY.staleTime;
            const filterId = generateUniqueKey(filters, ['page']);
            const state = getState() as {auth: AuthState, contentLibrary: ContentLibrarySlice};
            if(filters.page === 1 && !force && isFresh(state.contentLibrary.filtered_lists?.[filterId]?.last_fetched_at ?? null, STALE_TIME)){
               return rejectWithValue(ERROR.CACHED);
            }
            const agencyId = state.auth.selectedAgencyId ?? '';
            if(!agencyId) throw new Error("AgencyId not found");

            const library = await fetchContentLibrary(agencyId, filters);

            return {library, filters, filterId};

        } catch (error) {
            return rejectWithValue('Failed to fetch campaign applications');
        }
    }
)